import script from "./NotesComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./NotesComponent.vue?vue&type=script&setup=true&lang=js"

import "./NotesComponent.vue?vue&type=style&index=0&id=4d7341ef&scoped=true&lang=css"

import exportComponent from "E:\\gcm3\\demo\\codebasezoom\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d7341ef"]])

export default __exports__